import { apiFetch } from "../utils/apiFetch"

export function createMark(data: any) {
  return apiFetch("/api/marks", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  })
}

export function getMarks() {
  return apiFetch("/api/marks")
}

export function updateMark(id: string, data: any) {
  return apiFetch(`/api/marks/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  })
}

export function deleteMark(id: string) {
  return apiFetch(`/api/marks/${id}`, { method: "DELETE" })
}
